import { useEffect } from "react";
import {
  ACTIVATION_CONFIRMATION_MODAL_KEY,
  useSessionStorage,
} from "react/components/NewVersionOptIn/OptInLandingPage/hooks/useSessionStorage";

import { useActivationConfirmationModal } from "..";

export const useRenderActivationConfirmationModal = () => {
  const modal = useActivationConfirmationModal();
  const { get: shouldShowModal, remove: disableShowingModalOnNextRender } =
    useSessionStorage<boolean>(ACTIVATION_CONFIRMATION_MODAL_KEY);

  useEffect(() => {
    if (shouldShowModal({ onErrorValue: true })) {
      disableShowingModalOnNextRender();
      void modal.show();
    }
  }, [modal, shouldShowModal, disableShowingModalOnNextRender]);
};
